export default function Pricing() {
  const pricingPlans = [
    {
      size: '1/4 Truck',
      price: '$150 - $200',
      badge: 'Small Jobs',
      badgeColor: 'bg-emerald-500',
      iconColor: 'text-emerald-500',
      description: 'Perfect for small cleanouts: single rooms, light furniture, and boxes. Fast, affordable, stress-free.',
      popular: false
    },
    {
      size: '1/2 Truck',
      price: '$300 - $350',
      badge: 'Most Popular',
      badgeColor: 'bg-sky-500',
      iconColor: 'text-sky-500',
      description: 'Medium cleanouts: garage, multiple furniture items, or small apartment move-outs. Quick, reliable, and eco-friendly.',
      popular: true
    },
    {
      size: '3/4 Truck',
      price: '$400- $500',
      badge: 'Large Jobs',
      badgeColor: 'bg-amber-500',
      iconColor: 'text-amber-500',
      description: 'Large cleanouts: multiple rooms or heavy furniture. We do the heavy lifting, you enjoy the space.',
      popular: false
    },
    {
      size: 'Full Truck',
      price: '$600- $700',
      badge: 'Complete Service',
      badgeColor: 'bg-[#FF6B4A]',
      iconColor: 'text-[#FF6B4A]',
      description: 'Whole-house cleanouts: clutter-free transformation. Complete service from pickup to responsible disposal.',
      popular: false
    }
  ];

  return (
    <section id="pricing" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#FF6B4A] text-xs font-bold uppercase tracking-widest mb-6">TRANSPARENT PRICING</p>
          <h2 className="text-5xl lg:text-6xl font-serif text-[#2C2C2C] mb-6">Choose Your Truck Size</h2>
          <p className="text-lg text-[#6B7280]">No hidden fees. Know your cost upfront.</p>
        </div>

        {/* Pricing Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pricingPlans.map((plan, index) => (
            <div 
              key={index}
              className={`relative bg-white rounded-2xl p-8 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl cursor-pointer ${
                plan.popular 
                  ? 'border-3 border-[#FF6B4A] bg-[#FFF5F2] shadow-lg' 
                  : 'border-2 border-[#E5E7EB] shadow-md'
              }`}
            >
              {/* Popular Ribbon */}
              {plan.popular && (
                <div className="absolute -top-3 -right-3 bg-[#FF6B4A] text-white text-xs font-bold px-4 py-1.5 rounded-full shadow-lg">
                  BEST VALUE
                </div>
              )}

              {/* Badge */}
              <div className={`${plan.badgeColor} text-white text-sm font-semibold px-4 py-2 rounded-lg inline-block mb-8`}>
                {plan.badge}
              </div>

              {/* Price */}
              <div className="mb-4">
                <span className="text-5xl font-bold text-[#2C2C2C]">{plan.price}</span>
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold text-[#2C2C2C] mb-5">{plan.size}</h3>

              {/* Description */}
              <p className="text-[#6B7280] text-sm leading-relaxed mb-8">
                {plan.description}
              </p>

              {/* Icon */}
              <div className={`flex items-center justify-center ${plan.iconColor}`}>
                <i className="ri-truck-line text-5xl"></i>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-[#6B7280] mb-6">Not sure which size you need?</p>
          <a 
            href="tel:+18435551234" 
            className="inline-flex items-center gap-2 bg-[#2C2C2C] text-white px-8 py-4 rounded-full hover:bg-[#1a1a1a] transition-all whitespace-nowrap text-base font-semibold"
          >
            <i className="ri-phone-fill"></i>
            Call for a Free Estimate
          </a>
        </div>

        {/* Pricing Disclosure */}
        <div className="mt-12 text-center">
          <p className="text-sm text-[#6B7280] max-w-2xl mx-auto">
            * Pricing based on standard truck capacity. Uniquely heavy or oversized items may require additional charges. Contact us for a free estimate tailored to your specific needs.
          </p>
        </div>
      </div>
    </section>
  );
}
